import { Tooltip, Typography } from "@mui/material";
import React from "react";
import { GoSync } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  completeDialContact,
  deleteAllDialContacts,
} from "../../../../adapters";
import {
  clearDialsToDelete,
  clearDialsToSync,
  setDialsLastSyncDate,
} from "../../../../config/redux/slices/dialerSlice";
import {
  selectDialsData,
  selectDialsToDelete,
  selectDialsToSync,
} from "../../../../config/redux/slices/dialerSlice/selectors";
import { fetchAllDials } from "../../../../config/redux/slices/dialerSlice/thunks";
import { formatDateToString } from "../../../../utils/date";
import { showErrors } from "../../../../utils/ui";
import { StyledSyncIcon } from "../../../Scheduler/components/StreakInfo/styles";
import { StyledPendingCalls } from "./styles";
import useCronKeyCheck from "../../../../hooks/useCronKeyCheck";

const PendingCalls = () => {
  const dispatch = useDispatch();
  const isCronJobKeySetup = useCronKeyCheck();
  const [processing, setProcessing] = React.useState(false);

  const dailyDials = useSelector(selectDialsData);
  const pendingCalls = dailyDials.data?.filter((d) => !d.completed).length || 0;

  const dialsToSync = useSelector(selectDialsToSync);
  const dialsToDelete = useSelector(selectDialsToDelete);

  const syncToServer = async () => {
    if (processing || !isCronJobKeySetup) return;
    setProcessing(true);
    if (dialsToSync.length) {
      let finalDialsToSync = structuredClone(dialsToSync);
      if (dialsToDelete.length) {
        finalDialsToSync = finalDialsToSync.filter((dial) =>
          dialsToDelete.includes(dial)
        );
      }
      if (finalDialsToSync) {
        try {
          await completeDialContact(finalDialsToSync);
          dispatch(clearDialsToSync());
        } catch (e) {
          showErrors(e);
        }
      }
    }
    if (dialsToDelete.length) {
      try {
        await deleteAllDialContacts(dialsToDelete);
        dispatch(clearDialsToDelete());
      } catch (e) {
        showErrors(e);
      }
    }
    dispatch(fetchAllDials());
    dispatch(setDialsLastSyncDate(formatDateToString(new Date())));
    setProcessing(false);
    toast.success("Sync complete");
  };
  return (
    <StyledPendingCalls>
      <Typography>Pending: {pendingCalls}</Typography>
      <Tooltip title="Sync">
        <StyledSyncIcon $processing={processing}>
          <GoSync onClick={syncToServer} size="24px" />
        </StyledSyncIcon>
      </Tooltip>
    </StyledPendingCalls>
  );
};

export default PendingCalls;
